import { render, staticRenderFns } from "./NotSuport.vue?vue&type=template&id=1c9fdca2&scoped=true&"
import script from "./NotSuport.vue?vue&type=script&lang=js&"
export * from "./NotSuport.vue?vue&type=script&lang=js&"
import style0 from "./NotSuport.vue?vue&type=style&index=0&id=1c9fdca2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c9fdca2",
  null
  
)

export default component.exports